// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"page_pageWrapper__3Ur02"};